import {
  DEFAULT_SETTLE_AGREEMENT,
  settleAgreementOptions,
} from "../../shared/constants/settleAgreement";

export const buildCustomerColumns = (
  provinceOptions: Array<{ label: string; value: string }>,
): any[] => [
  {
    title: "Mã khách hàng",
    dataIndex: "code",
    width: 150,
    fixed: "left",
    editType: "Input",
    editProps: {
      style: { width: "unset" },
    },
    filterDataIndex: "text",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Tìm theo tên hoặc mã khách hàng",
      },
    },
  },
  {
    title: "Tên",
    dataIndex: "name",
    width: 180,
    editType: "Input",
  },
  {
    title: "Tên đầy đủ",
    dataIndex: "fullName",
    width: 260,
    editType: "Input",
  },
  {
    title: "Số điện thoại",
    dataIndex: "phoneNumber",
    width: 150,
    editType: "Input",
  },
  {
    title: "Mã số thuế",
    dataIndex: ["businessLicense", "text"],
    width: 160,
    editType: "Input",
  },
  {
    title: "Thời hạn thanh toán",
    dataIndex: "settleAgreement",
    width: 180,
    editType: "SelectOption",
    editProps: {
      showSearch: true,
      allowClear: true,
      options: settleAgreementOptions,
      placeholder: "Chọn thời hạn thanh toán",
    },
    colReturn: (value: string) => value || DEFAULT_SETTLE_AGREEMENT,
  },
  {
    title: "Tỉnh/TP",
    dataIndex: ["address", "province"],
    width: 180,
    editType: "SelectOption",
    editProps: {
      allowClear: true,
      showSearch: true,
      optionFilterProp: "label",
      options: provinceOptions,
      placeholder: "Chọn tỉnh/thành phố",
    },
  },
  {
    title: "Địa chỉ",
    dataIndex: ["address", "text"],
    width: 280,
    editType: "Input",
  },
];
